// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b2929178","453":"594eda2c","455":"88dd724c","977":"08992908"}[chunkId] + ".chunk.js";
};